import * as React from "react";
import "../../style/fonts.css";
import "./mainreg.css";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import CtaButton from "../ctaButton/ctaButton";
import {
  registerWithFacebook,
  signOut,
  resetFaceNewUser
} from "src/store/actions/authActions";
import { connect } from "react-redux";
import {
  followUserAfter,
  redirectAfterLogin,
  resetRedirectVars,
  checkFollowList,
  resetFollowList
} from "../../store/actions/supportActions";
import translate from "../../translations/i18n";
import CtaFacebook from "../ctaFacebook/ctaFacebook";

export interface Props {
  registerWithFacebook(): void;
  resetFaceNewUser(): void;
  signOut(): void;
  regFaceError: any;
  isNewUser: any;
  userStatusToFollow: any;
  userToFollowWithoutLogIn: any;
  userIdToFollowWithoutLogIn: any;
  followUserAfter(uid, user): void;
  redirectAfterLogin(): void;
  redirectUserAfterLogIn: any;
  redirectUserAfterFollow: any;
  resetRedirectVars(): void;
  ownAuth: any;

  alreadyFollowingChecked: any;
  alreadyFollowing: any;
  checkFollowList: (uid, followID) => void;
  resetFollowList: () => void;
}

interface State {
  thirdPartyCookies: boolean;
}

class MainReg extends React.Component<Props, any> {
  constructor(props) {
    super(props);
    this.facebookRegister = this.facebookRegister.bind(this);
    this.state = {
      thirdPartyCookies: false
    };
  }

  async facebookRegister() {
    try {
      await this.props.registerWithFacebook();
    } catch (e) {
      console.log(e)
    }
  }

  componentDidMount() {
    this.checkForThirdPartyCookies();
    this.props.resetFollowList();
    console.log("====================================");
    console.log(this.props.ownAuth);
    console.log("====================================");
  }

  componentDidUpdate() {
    if (this.props.isNewUser === true) {
      this.props.resetFaceNewUser();
    } else if (this.props.isNewUser === false) {
      this.props.resetFaceNewUser();
    }

    if (
      this.props.ownAuth.isEmpty === false &&
      this.props.userStatusToFollow === true
    ) {
      this.props.checkFollowList(
        this.props.ownAuth.uid,
        this.props.userToFollowWithoutLogIn.uid
      );
      this.props.redirectAfterLogin();
    }
  }

  componentWillUnmount() {
    console.log("ALREADY FOLLOWING: " + this.props.alreadyFollowing);
    if (
      this.props.alreadyFollowing === false &&
      !(this.props.isNewUser === true)
    ) {
      this.props.followUserAfter(
        this.props.ownAuth.uid,
        this.props.userToFollowWithoutLogIn
      );
    }
  }

  checkForThirdPartyCookies = () => {
    const receiveMessage = function(evt) {
      if (evt.data === "MM:3PCunsupported") {
        this.setState({ thirdPartyCookies: false });
      } else if (evt.data === "MM:3PCsupported") {
        this.setState({ thirdPartyCookies: true });
      }
    };
    window.addEventListener("message", receiveMessage.bind(this), false);
  };

  displayCookieWarning = () => {
    if (!this.state.thirdPartyCookies) {
      return (
        <div className="REG_COOKIE_INFO">
          <div className="SMALL_TEXT2">
            {translate("COOKIE_ERROR_LOGIN")
              .split("\n")
              .map((element, i) => {
                return <div key={i}>{element}</div>;
              })}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    if (this.props.isNewUser === true) {
      return <Redirect to="/registerFacebook" push />;
    } else if (
      (this.props.isNewUser === false &&
        this.props.userStatusToFollow === null) ||
      this.props.ownAuth.uid
    ) {
      return <Redirect to="/overview" push />;
    } else if (
      this.props.redirectUserAfterLogIn === true &&
      this.props.alreadyFollowingChecked === true
    ) {
      const userId = this.props.userIdToFollowWithoutLogIn;
      this.props.resetRedirectVars();
      return <Redirect to={`/profile/${userId}`} push />;
    }

    return (
      <div className="MAINREG">
        {/* The iframe is used to check if third party cookies are enabled. It is not visible */}
        <iframe
          src="https://smokeless-website.web.app/cookies/start.html"
          style={{ display: "none" }}
        />
        <div className="MAINREG_CENTER">
          <div className="REG_TITLE_MAIN">
            <div className="TITLE_2">
              {translate("SUPPORT_REGISTER_AND_LOGIN_TITLE")}
            </div>
          </div>
       

          <this.displayCookieWarning />
          <div className="REG_LOG_NAV">
            <div className="REG_TITLE_2">
              <div className="SMALL_TEXT1">
                {translate("CTA_REGISTER_TITLE")}
              </div>
            </div>
            <Link to="/registerEmail">
              <div className="REG_BUTTON">
                <CtaButton
                  width={"155px"}
                  text={translate("CTA_NEW_ACCOUNT")}
                  color={"white"}
                />
              </div>
            </Link>
            <div className="LOGIN_TITLE_2">
              <div className="SMALL_TEXT1">{translate("CTA_LOGIN_TITLE")}</div>
            </div>
            <Link to="/login">
              <div className="LOGIN_BUTTON">
                <CtaButton
                  width={"155px"}
                  text={translate("CTA_LOGIN")}
                  color={"blue"}
                />
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    regFaceError: state.auth.faceRegerror,
    isNewUser: state.auth.faceNewUser,
    userStatusToFollow: state.sup.userStatustoFollow,
    userIdToFollowWithoutLogIn: state.sup.userIdToFollowWithoutLogIn,
    userToFollowWithoutLogIn: state.sup.userToFollowWithoutLogIn,
    ownAuth: state.firebase.auth,
    redirectUserAfterLogIn: state.sup.redirectUserAfterLogIn,
    redirectUserAfterFollow: state.sup.redirectUserAfterFollow,
    alreadyFollowingChecked: state.sup.alreadyFollowingChecked,
    alreadyFollowing: state.sup.alreadyFollowing
  };
};

const mapDispatchToProps = dispatch => {
  return {
    registerWithFacebook: () => dispatch(registerWithFacebook()),
    signOut: () => dispatch(signOut()),
    resetFaceNewUser: () => dispatch(resetFaceNewUser()),
    followUserAfter: (uid, user) => dispatch(followUserAfter(uid, user)),
    redirectAfterLogin: () => dispatch(redirectAfterLogin()),
    resetRedirectVars: () => dispatch(resetRedirectVars()),
    checkFollowList: (uid, followId) =>
      dispatch(checkFollowList(uid, followId)),
    resetFollowList: () => dispatch(resetFollowList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainReg);



// WEBPACK FOOTER //
// ./src/components/Registration/mainreg.tsx